
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7.801 16.756"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 8355"}},[_c('g',{attrs:{"data-name":"Group 8354","fill":"none","stroke":"#109a50","stroke-width":".5","transform":"translate(15721.9 6204.356)"}},[_c('rect',{attrs:{"data-name":"Rectangle 6033","width":"7","height":"13","rx":"1.085","transform":"translate(-15721.5 -6201)","stroke-miterlimit":"10"}}),_c('path',{attrs:{"data-name":"Rectangle 6034","stroke-linecap":"round","stroke-linejoin":"round","d":"M-15720.5-6203.957h5v2.956h-5z"}}),_c('g',{attrs:{"data-name":"Group 8353","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Line 341","d":"M-15717-6203.957v2.957"}}),_c('path',{attrs:{"data-name":"Line 342","d":"M-15719-6203.957v2.957"}})])])])])
          )
        }
      }
    